<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 
              | Búsqueda de Artículos
              | &nbsp
              a.button.is-dark.is-rounded.is-medium(@click="backPage")
                i.fas.fa-times
              br
        .columns.has-text-centered(v-show="tipoSalida === 's'")
          .column.is-offset-3.is-6
            router-link.a.button.is-text.is-rounded.is-medium(to="/Inventario/Salidas" )
              | Ver Salidas
          .column.is-3
            CarritoSalida(@hover="mostrarListaCarrito")
            ListaArticulosSalida(v-show="verListaCarrito" @hover="mostrarListaCarrito")
        .columns.has-text-centered(v-show="tipoSalida === 'a'")
          .column.is-offset-3.is-6
            router-link.a.button.is-text.is-rounded.is-medium(to="/Inventario/Asignaciones")
              | Ver Asignaciones
          .column.is-3
            CarritoSalida(@hover="mostrarListaCarrito")
            ListaArticulosSalida(v-show="verListaCarrito" @hover="mostrarListaCarrito")
        .columns.has-text-centered(v-show="tipoSalida === 'p'")
          .column.is-offset-3.is-6
            router-link.a.button.is-text.is-rounded.is-medium(to="/Inventario/Prestamos")
              | Ver Préstamos
          .column.is-3
            CarritoSalida(@hover="mostrarListaCarrito")
            ListaArticulosSalida(v-show="verListaCarrito" @hover="mostrarListaCarrito")
        .columns.has-text-centered
          .column.is-6(v-show="isAdmin")
            input#allH.is-checkradio.is-black(type='radio', value='ALL' v-model='query' checked='checked')
            label.is-size-6(for='allH') Todos
            input#tpaH.is-checkradio.is-black(type='radio', value='TPA' v-model='query')
            label.is-size-6(for='tpaH') TPA
            input#eb04H.is-checkradio.is-black(type='radio', value='EB04' v-model='query')
            label.is-size-6(for='eb04H') EB04
            input#corpH.is-checkradio.is-black(type='radio', value='CORP' v-model='query')
            label.is-size-6(for='corpH') CORP.
          .column.is-4(:class="isAdmin ? 'is-offset-2': 'is-offset-8'")
            .field
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder=' Marca | Serie | Modelo',
                  v-model="query_articulos",
                )
        .columns(v-show="result_query != ''")
          .column.is-offset-8.is-4
            span.tag.is-black.is-small {{ result_query }}
        .columns
          .column.is-12
            .div
              .columns.is-multiline(v-show="hayArticulos")
                .column.is-3(v-for="art in articulosShow")
                  CardArticulo(:articulo="art" :isSelected="checkSelect(art.id)" :origen="origen")
              .columns
                .column(v-show="!hayArticulos")
                  .notification.is-warning
                    button.delete
                    |   No hay Artículos para estos filtros.
</template>

<script>
import Loader from '../shared/Loader.vue'
import HeaderInventario from './layout/HeaderInventario.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import CardArticulo from '@/components/inventario_Componentes/CardArticulo.vue'
import CarritoSalida from '@/components/inventario_Componentes/CarritoSalida.vue'
import ListaArticulosSalida from '@/components/inventario_Componentes/ListaArticulosSalida.vue'
import InventarioServices from '../../services/inventario/inventario'
import moment from 'moment'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { mapState } from 'vuex'

export default {
  name: 'Busqueda',
  components: { Loader, NavBarInventario, HeaderInventario, CardArticulo, CarritoSalida, ListaArticulosSalida, vueCustomScrollbar },
  data () {
    return {
      isLoading: true,
      articulos: [],
      articulosShow: [],
      articulosSelect: [],
      hayDatos: false,
      idItemSel: '',
      catSelected: {},
      subCategorias: [],
      subCatSelected: {},
      hayArticulos: true,
      verListaCarrito: false,
      settings: {
        maxScrollbarLength: 60
      },
      query_articulos: '',
      query: 'ALL',
      isAdmin: false,
      result_query: '',
      almacenes: [],
      origen: {},
    }
  },
  watch: {
    query () {
      if (this.query === 'ALL') {
        this.articulosShow = this.articulos
      } else {
        this.articulosShow = this.articulos.filter( (art)=> art.ubicacion === this.query )
      }
    },
    query_articulos () {
      const QUERY_ARTICULOS = this.query_articulos.toUpperCase()
      if (this.query_articulos.length > 0) {
        const artFilter = this.articulos.filter( arts => { 
          return `${arts.modelo} ${arts.marca} ${arts.serie} ${arts.categoria} `.toUpperCase().includes(QUERY_ARTICULOS)
        }) 
        this.articulosShow = artFilter
        this.result_query = this.articulosShow.length === 1 ? `Se encontró ${this.articulosShow.length} coincidencia.` : `Se encontraron ${this.articulosShow.length} coincidencias.`
      } else {
        this.articulosShow = this.articulos
        this.result_query = ''
      }
    }
  },
  methods: {
    iniciarComponente() {
      switch (this.userLogin.categoria) {
        case 0:
          this.isAdmin = false
          break
        case 1:
          this.isAdmin = false
          break
        case 2:
          this.isAdmin = false
          break
        case 3:
          this.isAdmin = false
          break
        default:
          this.isAdmin = false
          break
      }
      this.obtenerAlmacenes()
    },
    obtenerArticulos () {
      let ubi = ''
      if (this.isAdmin) {
        ubi = 'ALL'
      } else {
        ubi = this.userLogin.ubicacion === 'CORPORATIVO' ? 'CORP' : this.userLogin.ubicacion
      }

      if (this.almacenSelect === '') {
        console.log('Aqui es con GIA')
        InventarioServices.getArticulosAlmacenGIA(ubi)
          .then(res => {
            console.log(res.data)
            if (this.isAdmin) {
              this.articulos = res.data
              this.articulosShow = this.articulos
            } else {
              let almacen = ''
              switch (this.userLogin.ubicacion) {
                case 'EB04':
                  almacen = 'EB04-ALG'
                  break
                case 'TPA':
                  almacen = 'TPA-ALS'
                  break
                case 'CORPORATIVO':
                  almacen = 'CORP-ALG'
                  break
                default:
                  almacen = ''
                  break
              }
              this.articulos = res.data.filter(item => item.oficina === almacen)
              this.articulosShow = this.articulos
            }
            if (this.articulos.length > 0) {
              this.hayArticulos = true
            } else {
              this.hayArticulos = false
            }
            this.isLoading = false
          })
          .catch( e => {
            console.log(e.message)
          })
      } else {
        
        InventarioServices.getArticulosAlmacenCede(this.origen.clave)
          .then(res => {
            console.log(res.data)
            if (this.isAdmin) {
              this.articulos = res.data
              this.articulosShow = this.articulos
            } else {
              this.articulos = res.data
              this.articulosShow = this.articulos
            }
            if (this.articulos.length > 0) {
              this.hayArticulos = true
            } else {
              this.hayArticulos = false
            }
            this.isLoading = false
          })
          .catch( e => {
            console.log(e.message)
          })
      }

      
    },
    irProductoDetalle (id) {
      setTimeout(() => {
        this.$router.push({ path: `/ArticuloDetalle/${id}` })
      }, 250)
    },
    getTipo: function (id) {
      let result;
      let type = this.tipos.filter(tipo => tipo.id === id)
      let tipoEnc = type[0]
      if (tipoEnc.subclase === '') {
        result = tipoEnc.nombre
      } else {
        result = `${tipoEnc.nombre} (${tipoEnc.subclase})`
      }

      return result
    },
    selectItem(index, item) {
      this.idItemSel = item.id
    },

    mostrarListaCarrito (result) {
      this.verListaCarrito = result
    },
    scrollHanle(evt) {
    },
    checkSelect (idArt) {
      let existe = this.articulos_Salida.filter( arts => arts.id === idArt)
      let isSelect = false
      if (existe.length > 0) {
        isSelect = true
      } else {
        isSelect = false
      }
      return isSelect
    },
    backPage() {
      this.$router.back()
    },
    obtenerAlmacenes() {
      InventarioServices.getAlmacenesConsumibles('c')
        .then( data => {
          this.almacenes = data.map(this.convertirAlmacenes)
          this.obtenerAlmacenOrigen()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },
    convertirAlmacenes (ofi) {
      return {
        ...ofi,
        id: parseInt(ofi.id),
        id_ubicacion: parseInt(ofi.id_ubicacion),
        id_oficina: parseInt(ofi.id_oficina),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
      }
    },
    obtenerAlmacenOrigen() {
      this.almacenes.map( alm => {
        const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
        if (encontrado) {
          this.origen = alm
        }
      })
      this.obtenerArticulos()
    },
  },
  created () {
    this.iniciarComponente()
  },
  computed: {
    ...mapState(['userLogin', 'articulos_Salida', 'tipoSalida', 'almacenSelect'])
  }
}
</script>

<style scoped>

  .scroll-area {
    position: relative;
    margin: auto;
    height: 400px;
    /* border-radius: 5px 5px 5px 5px; */
    /* border: 1px solid #54545c; */
  }
  .ps__thumb-x, .ps__thumb-y {
    background-color: #54545c;
    width: 10px;
  } 
  
</style>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/Busqueda.vue